import Vue from "vue";
import Router from "vue-router";

import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/terms",
            name: "terms",
            component: () => import(/* webpackChunkName: "terms" */ "./views/Terms.vue")
        },
        {
            path: "/page-404",
            name: "page-404",
            component: () => import(/* webpackChunkName: "error-pages" */ "./views/Error404.vue")
        },
        {
            path: "/page-505",
            name: "page-505",
            component: () => import(/* webpackChunkName: "error-pages" */ "./views/Error505.vue")
        },
        {
            path: "/users/forgot-password",
            name: "forgot-password",
            component: () => import(/* webpackChunkName: "password" */ "./views/UserPasswordForgot.vue")
        },
        {
            path: "/users/reset-password/:code",
            name: "reset-password",
            component: () => import(/* webpackChunkName: "password" */ "./views/UserPasswordReset.vue")
        },
        {
            path: "*",
            component: () => import(/* webpackChunkName: "error-pages" */ "./views/Error404.vue")
        }
    ]
})